import { EventType, AnnouncementRequestsModel, Lookup, RequestBuildingUnitView, EventParking, CompanyBuildingUnitView, FMIssueList, FMGeneralRequestModel, FMAllRequestsModel, RequestVenue, EventRequestModel, RequestGeneral, AppFile } from '@app/core';
import * as DashboardActions from '../actions/dashboard.actions';



export interface State {
  dashboardRequest: FMAllRequestsModel[] | null;
  serverTotal: number | 0;
  pushedAnnouncement: AnnouncementRequestsModel[] | null;
  upcomingMeetings: RequestVenue[] | null;
  meetingsTotal: number | 0;
  upcomingEvents: EventRequestModel[] | null;
  eventsTotal: number | 0;
  allRequests: RequestGeneral[] | null;
  resourceCenterFiles: AppFile[] | null;
}

export const initialState: State = {
  dashboardRequest: null,
  serverTotal: 0,
  pushedAnnouncement: null,
  upcomingMeetings: null,
  meetingsTotal: 0,
  upcomingEvents: null,
  eventsTotal: 0,
  allRequests: null,
  resourceCenterFiles: null,
}


export function reducer(state = initialState, action: DashboardActions.DashboardActionType): State {
  switch (action.type) {

    case DashboardActions.DashboardAction.DashboardRequests: {
      return {
        ...state,
        dashboardRequest: null
      };

    }



    case DashboardActions.DashboardAction.DashboardRequestsSuccess: {

      return {
        ...state,
        dashboardRequest: action.payload.items,
        
        serverTotal: action.payload.paging.totalItems
      };

    }


    case DashboardActions.DashboardAction.LoadPushedAnnouncements: {
      return {
        ...state,
        pushedAnnouncement: null
      };
    }


    case DashboardActions.DashboardAction.LoadPushedAnnouncementsSuccess: {

      return {
        ...state,
        pushedAnnouncement: action.payload
      };
    }

    case DashboardActions.DashboardAction.LoadUpcomingMeetings: {
      return {
        ...state,
        upcomingMeetings: null
      };

    }



    case DashboardActions.DashboardAction.LoadUpcomingMeetingsSuccess: {

      return {
        ...state,
        upcomingMeetings: action.payload.items,
        meetingsTotal: action.payload.paging.totalItems
      };

    }


    case DashboardActions.DashboardAction.LoadUpcomingEvents: {
      return {
        ...state,
        upcomingEvents: null
      };

    }

    case DashboardActions.DashboardAction.LoadUpcomingEventsSuccess: {
      return {
        ...state,
        upcomingEvents: action.payload.items,
        eventsTotal: action.payload.paging.totalItems
      };

    }

    case DashboardActions.DashboardAction.LoadAllRequests: {
      return {
        ...state,
        allRequests: null
      };
    }


    case DashboardActions.DashboardAction.LoadAllRequestsSuccess: {

      return {
        ...state,
        allRequests: action.payload
      };
    }

    case DashboardActions.DashboardAction.LoadResourceCenter: {
      return {
        ...state,
        resourceCenterFiles: null
      };
    }


    case DashboardActions.DashboardAction.LoadResourceCenterSuccess: {

      return {
        ...state,
        resourceCenterFiles: action.payload
      };
    }

    default: {
      return state;
    }
  }
}

export const getdashboardRequest = (state: State) => state.dashboardRequest;
export const selectdashboardRequestTotal = (state: State) => state.serverTotal;
export const getPushedAnnouncements = (state: State) => state.pushedAnnouncement;
export const getUpcomingMeetings = (state: State) => state.upcomingMeetings;
export const selectMeetingsTotal = (state: State) => state.meetingsTotal;
export const getUpcomingEvents = (state: State) => state.upcomingEvents;
export const selectEventsTotal = (state: State) => state.eventsTotal;
export const getAllRequests = (state: State) => state.allRequests;
export const getResourceCenterFiles = (state: State) => state.resourceCenterFiles;



// WEBPACK FOOTER //
// ./src/app/core/store/reducers/dashboard.reducers.ts